import {CheckListItem} from './CheckListItem.tsx'

type CheckListProps = {
    items: Array<object>;
    value: string;
}
export const CheckList = ({items, value}: CheckListProps) => {
    return (
        <ul className={'pl-3'}>
            {items.map(item => (
                <CheckListItem key={item.label} item={item} value={value} />
            ))}
        </ul>
    )
}
